module.exports = Promise.all([__parcel__import__("hzxtt"), __parcel__import__("efRGA")]).then(() => parcelRequire('4MH6n'));